import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PROJECTS } from '../../constants';

const ZrhClock = () => {
  const [time, setTime] = useState('');
  useEffect(() => {
    const read = () => {
      try {
        return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Zurich' }).format(new Date());
      } catch {
        return '--:--';
      }
    };
    setTime(read());
    const id = window.setInterval(() => setTime(read()), 30000);
    return () => window.clearInterval(id);
  }, []);
  return <time suppressHydrationWarning>{time || '--:--'}</time>;
};

export const HeroDeck = () => {
  const { t } = useTranslation();

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-10 md:pt-12">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-4 md:auto-rows-[minmax(156px,auto)]">
        <div className="tile md:col-span-2 md:row-span-2">
          <div className="tile-in flex flex-col justify-between gap-4 !p-6">
            <span className="hatch" aria-hidden="true" />
            <div>
              <p className="eyebrow text-primary">00 // COMPILED_PROFILE.ZRH</p>
              <p className="eyebrow mt-1 text-muted-foreground">{t('hero.greeting')}</p>
            </div>
            <h1 className="text-5xl sm:text-6xl md:text-7xl">
              {t('hero.title')}<span className="text-primary">.</span>
            </h1>
            <p className="max-w-xl text-lg md:text-xl text-foreground" style={{ fontFamily: 'var(--font-sans)', textTransform: 'none', letterSpacing: 0 }}>
              {t('hero.valueprop')}
            </p>
            <p className="max-w-xl text-sm text-muted-foreground" style={{ textTransform: 'none' }}>
              {t('hero.description')}
            </p>
            <div className="flex flex-wrap gap-3">
              <a href="#projects" className="btn-primary">{t('hero.cta.projects')}</a>
              <a href="#contact" className="btn-outline">
                {t('hero.cta.contact')}
              </a>
            </div>
            <p className="eyebrow text-muted-foreground">BRIEF → PROTOTYPE → <span className="text-primary">BUILD</span> → SHIP</p>
            <p className="eyebrow text-muted-foreground">{t('hero.credibility')}</p>
          </div>
        </div>

        <div className="tile" data-reveal>
          <div className="tile-in flex flex-col justify-between">
            <span className="hatch" aria-hidden="true" />
            <p className="eyebrow">ZRH_NOW</p>
            <div className="font-display text-4xl font-extrabold text-foreground tabular-nums"><ZrhClock /></div>
            <p className="eyebrow text-muted-foreground">EUROPE/ZURICH</p>
          </div>
        </div>

        <div className="tile" data-reveal>
          <div className="tile-in flex flex-col justify-between">
            <p className="eyebrow">{t('hero.status.title')}</p>
            <p className="font-mono text-sm text-primary">
              <span className="live-dot mr-2" aria-hidden="true" />
              <span aria-hidden="true">=== </span>
              {t('hero.status.available')}
            </p>
            <p className="eyebrow text-muted-foreground">{t('hero.status.scope')}</p>
          </div>
        </div>

        <div className="tile" data-reveal>
          <div className="tile-in flex flex-col justify-between">
            <p className="eyebrow">STACK.RUNTIME</p>
            <div className="flex flex-wrap gap-1.5">
              {['React', 'Laravel', 'TypeScript', 'Cloudflare'].map((s) => (
                <span key={s} className="badge badge-secondary">{s}</span>
              ))}
            </div>
          </div>
        </div>

        <a href="#projects" className="tile tile-hover block" data-reveal>
          <div className="tile-in flex flex-col justify-between">
            <span className="hatch" aria-hidden="true" />
            <p className="eyebrow">02 // SELECTED_WORK</p>
            <p className="font-display text-3xl font-extrabold tabular-nums">{String(PROJECTS.filter((p) => p.featured).length).padStart(2, '0')} <span className="text-muted-foreground">{t('hero.workCount')}</span></p>
            <p className="eyebrow text-primary">OPEN() ↓</p>
          </div>
        </a>
      </div>
    </section>
  );
};
